import React, { useEffect } from "react"
import { graphql } from 'gatsby'
import { useTheme }  from '~/contexts/ThemeContext'
import useAnalytics from '~/utils/analytics'
import { imgSize } from '~/utils/helpers'

import { Seo } from '~/components/shared/seo'
import Blocks from '~/components/home/blocks'

export default function HomePage({ data: { homepage: { data } } }) {  
  const { gender } = useTheme()
  const { ana_home } = useAnalytics()

  const currGender = gender

  useEffect(() => {
    ana_home()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (currGender === gender) return
    ana_home()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gender])
  

  return (
    <Blocks data={data} />
  );
}


export const Head = ({ data: { homepage } }) => {
  const { gender, isMobile } = useTheme()

  let all_imgs = homepage.data.filter(x => x.gender === gender && x.type !== 'products')
  all_imgs = all_imgs.flatMap(block => {

    if (block.type === 'journal') return block.image ? imgSize(block.image,900) : null
    if (block.type === 'two_img' || block.type === 'two_off') {
      return block.images.map(x => x.image ? imgSize(x.image,900) : null)
    }
    if (!block.images) return null

    const item = block.images[0]
    const img = isMobile ? item.mobile_image : item.image
    const desksize = (block.type === 'hero_wide' || block.type === 'full_bleed') ? 1800 : 1400

    if (!img) return null

    if (isMobile) return [imgSize(img,900), imgSize(img,10)]
    return [imgSize(img, desksize), imgSize(img,10)]
  })
  all_imgs = all_imgs.filter(x => !!x)

  let seo_image = homepage.image
  const default_img = 'https://cdn.shopify.com/s/files/1/0123/5065/2473/files/BuckMason_HancockPark_Store_2_85d9cd31-8016-441a-9045-d03b74d1b329.jpg?v=1710804802'
  const firstimg = homepage.data.filter(x => x.type === 'full_bleed' || x.type === 'hero' || x.type === 'hero_wide' )
      .find(x => x.images[0] && x.images[0].image !== null)
  if (!seo_image && firstimg) seo_image = firstimg.images[0].image
  if (!seo_image) seo_image = default_img

  return (
    <>
      <Seo 
        title={'Buck Mason® Official Site'}
        description={`Buck Mason makes updated, modern American classics with a commitment to timelessness, quality, and our California roots.`}
        image={seo_image}
        url={`/`}
      >
        <script id="prod_struc_data" type="application/ld+json">
          {`{
            "@context": "http://schema.org",
            "@type": "Organization",
            "name": "Buck Mason",
            "legalName":"Buck Mason Inc",
            "url": "https://www.buckmason.com",
            "logo": "https://cdn.shopify.com/s/files/1/0123/5065/2473/files/buck_mason.png?v=1663274121",
            "description":"Inspired by laid back California ethos of easy living, quality, & simplicity, Buck Mason is a modern American brand that makes fashion less complicated.",
            "telephone":"888-988-5560",
            "email":"help@buckmason.com",
            "sameAs": [
              "https://www.instagram.com/buckmason/",
              "https://www.facebook.com/buckmasonusa/",
              "https://www.linkedin.com/company/buck-mason",
              "https://en.wikipedia.org/wiki/Buck_Mason"
            ]
          }`}
        </script>
      </Seo>
      {all_imgs?.length > 0 && all_imgs.map(x =>
        <link key={x} rel="preload" href={x} as="image" type="image/jpeg" fetchpriority="high" />
      )}
    </>
  )
}


export const pageQuery = graphql`
  {
    homepage: contentPage(type: {eq: "Homepage"}) {
      data
      image
    }
  }
`;
